import { useMutation } from '@tanstack/react-query';
import { addHardwareProduct } from '../../../actionCreators/hardwareproduct';

export function useAddHardwareProduct() {
  return useMutation({
    mutationKey: ['add-hardware-product'],
    mutationFn: (product: any) => addHardwareProduct(product),
  });
}
